import { __assign } from "tslib";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRestrictToLoggedIn } from '../../../utils/hooks/useRestrictToLoggedIn';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import ActionBarItemWrapper from '../items/ActionBarItemWrapper';
import SubscribeToUnlockTooltip from '../SubscribeToUnlockTooltip';
/** Blocks an action/click on the given action bar button if:
 *  - loggedInOnly: sends the clicking user to sisu if anon
 *  - subscribersOnly: sends the clicking user to purchase the tier if unsubbed or,
 *    if locked-subscribed, just blocks the action
 *  Accepts the same props as ActionBarWrapper, allowing popups to work as normal.
 */
var ActionBarButtonRestricted = function (_a) {
    var button = _a.button, loggedInOnly = _a.loggedInOnly, subscribersOnly = _a.subscribersOnly, deviation = _a.deviation, restrictedActionName = _a.restrictedActionName, tooltip = _a.tooltip, forceVisibleTooltip = _a.forceVisibleTooltip, renderPopover = _a.renderPopover;
    var t = useTranslation().t;
    var _b = useRestrictToLoggedIn(), isLoggedIn = _b.isLoggedIn, restrictToLoggedIn = _b.restrictToLoggedIn;
    var _c = useSubscriptionTier(deviation), needsSubscription = _c.needsSubscription, isSubscribedButBlocked = _c.isSubscribedButBlocked;
    if (loggedInOnly && !isLoggedIn) {
        return (React.createElement(ActionBarItemWrapper, { tooltip: t('actionbar.download.mustLogIn'), forceVisibleTooltip: forceVisibleTooltip }, cloneWithUpdateClickBehaviour(button, {
            onClick: restrictedActionName
                ? restrictToLoggedIn(restrictedActionName)
                : undefined,
            href: undefined,
        })));
    }
    var actionBlockedBySubscription = needsSubscription || isSubscribedButBlocked;
    if (subscribersOnly && actionBlockedBySubscription) {
        return (React.createElement(SubscribeToUnlockTooltip, { deviation: deviation, forceVisible: forceVisibleTooltip }, cloneWithUpdateClickBehaviour(button, {
            onClick: undefined,
            href: undefined,
        })));
    }
    return (React.createElement(ActionBarItemWrapper, { tooltip: tooltip, renderPopover: renderPopover, forceVisibleTooltip: forceVisibleTooltip }, button));
};
ActionBarButtonRestricted.displayName = 'ActionBarButtonRestricted';
export default ActionBarButtonRestricted;
function cloneWithUpdateClickBehaviour(button, newProps) {
    return React.cloneElement(button, __assign(__assign(__assign({}, button.props), { download: undefined, target: undefined }), newProps), button.props.children);
}
//# sourceMappingURL=ActionBarButtonRestricted.js.map